import StepCard from "@/components/StepCard";
import EbookHeader from "@/partials/create/course/ebook/EbookHeader";
import { useTranslation } from "@vixi/localization";
import { RouteOptionsById, RouterIds } from "@vixi/router";
import { ButtonLink, PageMainContent, useGoBack } from "@vixi/ui";

// Constants
const grid_max_width = 1076;
const routeId = "/_app/create/ebook/" satisfies RouterIds;

// Route
export const CreateEbookCourseIndexPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  useGoBack({
    to: "/create",
    replace: true,
  });

  const { t } = useTranslation();

  return (
    <PageMainContent scrollable psY="none">
      <div className="m-auto" style={{ maxWidth: grid_max_width }}>
        <EbookHeader />
        <div className="mx-auto" style={{ maxWidth: grid_max_width }}>
          <h2 className="ar:font-medium ms-5 mt-7.5 font-bold">
            {t("CreateCourse.KnowledgeSourceStepsTitle")}
          </h2>

          <div className="mt-7.5 grid grid-cols-1 gap-7.5 md:grid-cols-2 lg:grid-cols-3">
            <div>
              <StepCard
                stepNumber={1}
                title={"CreateCourse.UploadEbook"}
                description={"CreateCourse.UploadEbookSubtitle"}
              />
            </div>
            <div>
              <StepCard
                stepNumber={2}
                title={"CreateCourse.CourseIsGenerated"}
                description={"CreateCourse.CourseIsGeneratedSubtitle"}
              />
            </div>
            <div>
              <StepCard
                stepNumber={3}
                title={"CreateCourse.UploadPicture"}
                description={"CreateCourse.UploadPictureSubtitle"}
              />
            </div>
            <div>
              <StepCard
                stepNumber={4}
                title={"CreateCourse.ReviewYourCourse"}
                description={"CreateCourse.ReviewYourCourseSubtitle"}
              />
            </div>
            <div>
              <StepCard
                stepNumber={5}
                title={"CreateCourse.HitPublish"}
                description={"CreateCourse.HitPublishSubtitle"}
              />
            </div>

            {/* Add the Upload button next to Card 5 */}
            <div className="flex items-center">
              <div className="mx-auto my-2.5">
                <ButtonLink
                  to="/create/ebook/flow"
                  size="large"
                  variant="contained"
                  className="px-8 py-4"
                >
                  {t("Action.LetsGetStarted")}
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageMainContent>
  );
}
